(function () {
  function initTabbedCollections(root) {
    if (!root) return;

    const tabButtons = Array.from(root.querySelectorAll("[data-tc-tab]"));
    const panels = Array.from(root.querySelectorAll("[data-tc-panel]"));

    if (!tabButtons.length || !panels.length) return;

    function setActive(tabEl) {
      const targetId = tabEl.getAttribute("data-tc-target");
      if (!targetId) return;

      tabButtons.forEach((btn) => {
        const isActive = btn === tabEl;
        btn.classList.toggle("is-active", isActive);
        btn.setAttribute("aria-selected", isActive ? "true" : "false");
        btn.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach((panel) => {
        const isTarget = panel.id === targetId;
        panel.toggleAttribute("hidden", !isTarget);
        panel.classList.toggle("is-active", isTarget);
      });
    }

    function getActiveIndex() {
      return tabButtons.findIndex((b) => b.getAttribute("aria-selected") === "true");
    }

    tabButtons.forEach((btn) => {
      btn.addEventListener("click", () => setActive(btn));

      btn.addEventListener("keydown", (e) => {
        const key = e.key;
        const currentIndex = getActiveIndex();
        const count = tabButtons.length;

        if (key === "ArrowRight" || key === "Right") {
          e.preventDefault();
          const next = tabButtons[(currentIndex + 1) % count];
          next.focus();
          setActive(next);
        } else if (key === "ArrowLeft" || key === "Left") {
          e.preventDefault();
          const prev = tabButtons[(currentIndex - 1 + count) % count];
          prev.focus();
          setActive(prev);
        } else if (key === "Home") {
          e.preventDefault();
          tabButtons[0].focus();
          setActive(tabButtons[0]);
        } else if (key === "End") {
          e.preventDefault();
          tabButtons[count - 1].focus();
          setActive(tabButtons[count - 1]);
        } else if (key === "Enter" || key === " ") {
          e.preventDefault();
          setActive(btn);
        }
      });
    });
  }

  function mountAll() {
    document.querySelectorAll("[data-tabbed-collections]").forEach(initTabbedCollections);
  }

  // Initial mount
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mountAll);
  } else {
    mountAll();
  }

  // Shopify Theme Editor support
  document.addEventListener("shopify:section:load", (e) => {
    const sectionEl = e.target;
    if (!sectionEl) return;
    const root = sectionEl.querySelector("[data-tabbed-collections]");
    if (root) initTabbedCollections(root);
  });

  document.addEventListener("shopify:section:select", (e) => {
    const sectionEl = e.target;
    if (!sectionEl) return;
    const root = sectionEl.querySelector("[data-tabbed-collections]");
    if (!root) return;

    // If a block is selected, try to activate its tab
    const selectedBlockId = e.detail && e.detail.blockId;
    if (!selectedBlockId) return;

    const tab = root.querySelector(`#tc-tab-${root.dataset.sectionId}-${selectedBlockId}`);
    if (tab) tab.click();
  });
})();